import React from "react";
import { StyledImageContainer, StyledImage } from "./index.styles";

export const ImageContainer = ({ image, alt, cssProps }) => {
  return (
    <StyledImageContainer cssProps={cssProps} sx={{ width: "100%" }}>
      <StyledImage src={image} alt={alt} cssProps={cssProps} />
    </StyledImageContainer>
  );
};
